






































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import SendEmailDialog from '@/components/SendEmailDialog.vue';
import FieldDefs from './FieldDefs';

@Component({
  components: {
    SendEmailDialog
  }
})
export default class VehicleLicensesDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public items: object[] = [];
  public recChassisNumber: object = {};
  public indexChassisNumber = -1;
  public dialogChassisNumber = false;
  public dialogDeleteChassisNumber = false;
  public isTrailer = false;

  public showSendMail() {
    const ref: any = this.$refs.layout;
    return ref && ref.rec && ref.rec.license_file;
  }
  public emailWasSent(id) {
    // const ref: any = this.$refs.layout;
    // this.$set(ref.rec, '', true);
  }

  public newChassisNumber(isTrailer: boolean) {
    const form: any = this.$refs.formChassisNumber;
    if (form) {
      form.resetValidation();
    }
    const rec = this.recChassisNumber as any;
    rec.chassisnumber_id = null;
    this.isTrailer = isTrailer;
    this.indexChassisNumber = -1;
    this.dialogChassisNumber = true;
  }

  public async setChassisNumber() {
    const form: any = this.$refs.formChassisNumber;
    if (form.validate()) {
      const ref: any = this.$refs.layout;
      const reclist = this.isTrailer ? ref.rec.trailers : ref.rec.trucks;
      const rec = this.recChassisNumber as any;

      if (this.indexChassisNumber === -1) {
        rec.sequencenr = reclist.length + 1;
        reclist.push({...rec});
      } else {
        reclist[this.indexChassisNumber] = {...rec};
        this.indexChassisNumber = -1;
      }
      this.dialogChassisNumber = false;
    }
  }
  public editChassisNumberItem(item, isTrailer: boolean) {
    const ref: any = this.$refs.layout;
    const reclist = this.isTrailer ? ref.rec.trailers : ref.rec.trucks;
    this.indexChassisNumber = reclist.indexOf(item);
    this.recChassisNumber = {...item};
    this.isTrailer = isTrailer;
    this.dialogChassisNumber = true;
  }
  public deleteChassisNumberItem(item, isTrailer: boolean) {
    const ref: any = this.$refs.layout;
    const reclist = isTrailer ? ref.rec.trailers : ref.rec.trucks;
    this.indexChassisNumber = reclist.indexOf(item);
    this.isTrailer = isTrailer;
    this.dialogDeleteChassisNumber = true;
  }
  public executeDeleteChassisNumber() {
    const ref: any = this.$refs.layout;
    const reclist = this.isTrailer ? ref.rec.trailers : ref.rec.trucks;
    reclist.splice(this.indexChassisNumber, 1);
  }

}
